module.exports = __webpack_public_path__ + "static/media/dust.339e2bfc.png";